import { cardPartCss, hideEmptyCardItemsCss, INK } from '../surface';

import type { ArmSpec } from '../armRegistry';

function armCss(scope: string): string {
  return (
    cardPartCss(
      'abstract',
      scope,
      `font-size: 15px; line-height: 1.5; color: ${INK};`,
    ) + hideEmptyCardItemsCss(scope)
  );
}

export const readingList: ArmSpec = {
  // Partial, not fallback, when nothing is truncated: the compaction half still
  // applies to every card, only the reading half has nothing to reveal.
  stamp: (ctx) => {
    const cards = ctx.cards();
    if (cards.length === 0) return { render_state: 'fallback' };

    return {
      render_state: cards.some((card) => card.hasHiddenAbstract)
        ? 'rendered'
        : 'partial',
    };
  },

  onReady: (ctx) => {
    ctx.injectStyles(armCss(ctx.scope));
  },

  onCards: (cards) => {
    cards.forEach((card) => {
      card.expandAbstract();
      card.hideThumbnail();
    });
  },
};
